import { StrictFetcher } from '@this/src/util';
import React from 'react';
import { styled } from '@this/constants/themes';
import { css } from 'styled-components';
import Header from '@this/shared/header/header';
import Footer from '@this/shared/footer/footer';
import ContentBody from '@this/shared/atoms/content_body';
import { reportError } from '@this/lib/bugsnag';
import type UsersJson from '../../../../../domain/user/user_json';
import User from '../../../../../domain/user/user';

interface Props {}

interface State {
  user: User | null;
}

const tableStyle: React.CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  tableLayout: 'fixed'
};

const fiveColumnWidths = ['10%', '10%', '28%', '28%', '24%'];

const renderColGroup = (widths: string[]) => (
  <colgroup>
    {widths.map((width, index) => (
      <col key={`${width}-${index}`} style={{ width }} />
    ))}
  </colgroup>
);

class Charges extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      user: null
    };
  }

  componentDidMount() {
    StrictFetcher.get<UsersJson>('/users.json', 'users/index.json').then(
      response => {
        const user = new User(response);
        this.setState({ user });
      },
      () => {
        this.setState({
          user: null
        });
      }
    );
  }

  render() {
    try {
      const { user } = this.state;
      return (
        <Wrap>
          <div className="charges__pc">
            <div>
              <Header user={user} />
              <Body>
                <InfoContent>
                  <Title>旅行業務取扱い料金表</Title>
                  <Small>
                    （この書面は旅行業法第12条の4に定める取引条件説明書面の一部となります。）
                    <br />
                    平素から、AI
                    Travelをご利用いただき、まことにありがとうございます。当社では、お客様のご希望によって旅行業務をお引き受けする場合、このご案内に記載された条件によってお引き受けいたします。あらかじめご了承くださいますようお願い申し上げます。また、このご案内に記載のない事項については当社旅行業約款によります。
                  </Small>
                  <SubTitle>国内旅行</SubTitle>
                  <table style={tableStyle}>
                    {renderColGroup(fiveColumnWidths)}
                    <tbody>
                      <tr>
                        <Th colSpan={2}>区分</Th>
                        <Th>内容</Th>
                        <Th>料金</Th>
                        <Th>適用条件</Th>
                      </tr>
                      <tr>
                        <Td rowSpan={7}>取扱料金</Td>
                        <Td>宿泊手配</Td>
                        <Td>宿泊機関の手配</Td>
                        <Td rowSpan={4}>
                          1件につき旅行費用総額の20%以内
                          <br />
                          (旅行費用総額が5,500円未満の場合は1,100円を申し受けます)
                        </Td>
                        <Td rowSpan={4}>
                          旅行契約成立後、お客様のお申し出により、旅行を中止される場合でも、取扱料金を収受いたします。
                        </Td>
                      </tr>
                      <tr>
                        <Td>運送機関手配</Td>
                        <Td>運送機関等を手配する場合</Td>
                      </tr>
                      <tr>
                        <Td>レンタカー手配</Td>
                        <Td>レンタカーの手配</Td>
                      </tr>
                      <tr>
                        <Td>航空券手配</Td>
                        <Td>航空券を手配する場合</Td>
                      </tr>
                      <tr>
                        <Td>複合手配</Td>
                        <Td>運送機関と宿泊機関等の複合手配の場合</Td>
                        <Td>旅行費用総額の20%以内</Td>
                        <Td />
                      </tr>
                      <tr>
                        <Td>現地交通機関手配</Td>
                        <Td>現地交通機関（鉄道・バス等）</Td>
                        <Td>旅行費用総額の20%以内（1件につき下限2,200円）</Td>
                        <Td />
                      </tr>
                      <tr>
                        <Td>その他サービス手配</Td>
                        <Td>入場券・現地観光・送迎・ガイド・レストラン・船舶等その他のサービスの手配</Td>
                        <Td>
                          1件につき5,500円以上 手配金額の20%以内
                          <br />
                          (手配金額が25,000円未満の場合は5,500円を申し受けます)
                        </Td>
                        <Td>入場券・チケットの変更・払戻はできません</Td>
                      </tr>
                      <tr>
                        <Td>受注型・募集型企画旅行の取扱料金</Td>
                        <Td>受注型・募集型企画旅行の取扱料金</Td>
                        <Td>運送機関と宿泊機関等の複合手配の場合</Td>
                        <Td>旅行費用総額の20%以内</Td>
                        <Td />
                      </tr>
                      <tr>
                        <Td rowSpan={3}>変更・取消・払戻手続料金</Td>
                        <Td>取消手続</Td>
                        <Td rowSpan={3}>
                          運送・レンタカー・宿泊・入場・拝観・食事、複合手配等の
                          <br />
                          予約取消･変更・払戻
                        </Td>
                        <Td rowSpan={3}>変更前の旅行費用の20%以内</Td>
                        <Td rowSpan={3}>
                          サービス提供機関等の定める取消料・違約料その他の名目で既に支払いまたはこれから支払う費用は別途申し受けます
                        </Td>
                      </tr>
                      <tr>
                        <Td>変更手続</Td>
                      </tr>
                      <tr>
                        <Td>払戻手続</Td>
                      </tr>
                      <tr>
                        <Td>その他</Td>
                        <Td>通信連絡料金</Td>
                        <Td>お客さまのご依頼により緊急に現地手配・取消・変更等のため通信連絡を行った場合</Td>
                        <Td>1件あたり1,100円を申し受けます</Td>
                        <Td />
                      </tr>
                    </tbody>
                  </table>
                  <SubTitle>海外旅行</SubTitle>
                  <table style={tableStyle}>
                    {renderColGroup(fiveColumnWidths)}
                    <tbody>
                      <tr>
                        <Th colSpan={2}>区分</Th>
                        <Th>内容</Th>
                        <Th>料金</Th>
                        <Th>適用条件</Th>
                      </tr>
                      <tr>
                        <Td rowSpan={7}>取扱料金</Td>
                        <Td>宿泊手配</Td>
                        <Td>宿泊機関の手配する場合</Td>
                        <Td rowSpan={5}>旅行費用総額の20%以内</Td>
                        <Td rowSpan={6}>
                          旅行契約成立後、お客様のお申し出により、旅行を中止される場合でも、取扱料金を収受いたします。
                        </Td>
                      </tr>
                      <tr>
                        <Td>運送機関手配</Td>
                        <Td>運送機関等を手配する場合</Td>
                      </tr>
                      <tr>
                        <Td>レンタカー手配</Td>
                        <Td>レンタカーの手配</Td>
                      </tr>
                      <tr>
                        <Td>航空券手配</Td>
                        <Td>航空券を手配する場合</Td>
                      </tr>
                      <tr>
                        <Td>複合手配</Td>
                        <Td>運送機関と宿泊機関等の複合手配の場合</Td>
                      </tr>
                      <tr>
                        <Td>現地交通機関手配</Td>
                        <Td>現地交通機関（鉄道・バス等）</Td>
                        <Td>旅行費用総額の20%以内（1件につき下限2,200円）</Td>
                      </tr>
                      <tr>
                        <Td>その他サービス</Td>
                        <Td>入場券・現地観光・送迎・ガイド・レストラン・船舶等その他のサービス</Td>
                        <Td>
                          1件につき5,500円以上 手配金額の20%以内
                          <br />
                          (手配金額が25,000円未満の場合は5,500円を申し受けます)
                        </Td>
                        <Td>入場券・チケットの変更・払戻はできません</Td>
                      </tr>
                      <tr>
                        <Td>受注型・募集型企画旅行の取扱料金</Td>
                        <Td>受注型・募集型企画旅行の取扱料金</Td>
                        <Td>運送機関と宿泊機関等の複合手配の場合</Td>
                        <Td>旅行費用総額の20%以内</Td>
                        <Td />
                      </tr>
                      <tr>
                        <Td rowSpan={3}>変更・取消・払戻手続料金</Td>
                        <Td>取消手続</Td>
                        <Td rowSpan={3}>
                          運送・レンタカー・宿泊・入場・拝観・食事、複合手配・その他サービス等の
                          <br />
                          予約取消･変更・払戻
                        </Td>
                        <Td rowSpan={3}>旅行費用総額の40%以内（下限1,100円）</Td>
                        <Td />
                      </tr>
                      <tr>
                        <Td>変更手続</Td>
                        <Td />
                      </tr>
                      <tr>
                        <Td>払戻手続</Td>
                        <Td />
                      </tr>
                      <tr>
                        <Td>その他</Td>
                        <Td>通信連絡料金</Td>
                        <Td>お客さまのご依頼により緊急に現地手配・取消・変更等のため通信連絡を行った場合</Td>
                        <Td>1件あたり1,100円を申し受けます</Td>
                        <Td />
                      </tr>
                    </tbody>
                  </table>
                  <SubTitle>旅行相談契約</SubTitle>
                  <table style={tableStyle}>
                    {renderColGroup(fiveColumnWidths)}
                    <tbody>
                      <tr>
                        <Th colSpan={2}>区分</Th>
                        <Th>内容</Th>
                        <Th>料金</Th>
                        <Th>適用条件</Th>
                      </tr>
                      <tr>
                        <Td />
                        <Td>相談・助言</Td>
                        <Td>お客様の依頼による旅行相談</Td>
                        <Td>
                          国内・海外共通：
                          <br />
                          1件あたり66,000円以内
                        </Td>
                        <Td />
                      </tr>
                      <tr>
                        <Td />
                        <Td>旅行日程表（旅行計画）の作成</Td>
                        <Td>旅行日程表（旅行計画）の作成</Td>
                        <Td>
                          国内・海外共通：
                          <br />
                          1件あたり66,000円以内
                        </Td>
                        <Td />
                      </tr>
                      <tr>
                        <Td />
                        <Td>見積書作成</Td>
                        <Td>お客様の依頼による見積書の作成</Td>
                        <Td>
                          国内・海外共通：
                          <br />
                          見積費用総額の20%以内
                        </Td>
                        <Td>電話料その他の通信実費は別途申し受けます</Td>
                      </tr>
                      <tr>
                        <Td />
                        <Td>情報提供</Td>
                        <Td>旅行地及び運送・宿泊機関等の旅行サービス提供機関に関する情報提供</Td>
                        <Td>
                          国内・海外共通：
                          <br />
                          1件あたり66,000円以内
                        </Td>
                        <Td />
                      </tr>
                    </tbody>
                  </table>
                  <SubTitle>渡航手続代行料金</SubTitle>
                  <table style={tableStyle}>
                    {renderColGroup(fiveColumnWidths)}
                    <tbody>
                      <tr>
                        <Th colSpan={2}>区分</Th>
                        <Th>内容</Th>
                        <Th>料金</Th>
                        <Th>適用条件</Th>
                      </tr>
                      <tr>
                        <Td />
                        <Td>査証取扱い</Td>
                        <Td>査証（商用・業務査証の申請書作成と申請・受領代行）</Td>
                        <Td>66,000円以内</Td>
                        <Td>
                          1名1件1カ国につき
                          <br />
                          査証代実費や、査証取得のための手続きを委託する場合の査証取得手続代行業者の委託料は別途申し受けます。
                        </Td>
                      </tr>
                      <tr>
                        <Td />
                        <Td>緊急査証手続き</Td>
                        <Td>緊急査証手続き</Td>
                        <Td>66,000円以内</Td>
                        <Td>
                          1名1件1カ国につき、上記通常の査証料金と別途で発生します
                          <br />
                          取得のための手続きを委託する場合、取得手続代行業者の委託料は別途申し受けます
                        </Td>
                      </tr>
                      <tr>
                        <Td />
                        <Td>電子渡航認証</Td>
                        <Td>電子渡航認証</Td>
                        <Td>66,000円以内</Td>
                        <Td>
                          1名1件1カ国につき
                          <br />
                          手続き可能なものはESTA/ETAS/eTAの3種類です
                        </Td>
                      </tr>
                      <tr>
                        <Td />
                        <Td>出入国記録書</Td>
                        <Td>出入国カード/税関申告書などの記入</Td>
                        <Td>11,000円以内</Td>
                        <Td>
                          1名1件1カ国につき
                          <br />
                          出入国カードが入手出来る場合に限ります
                        </Td>
                      </tr>
                      <tr>
                        <Td />
                        <Td>その他</Td>
                        <Td>上記に含まれない手続き代行</Td>
                        <Td>66,000円以内</Td>
                        <Td>
                          1名1件1手配につき
                          <br />
                          当社がお引き受け可能と判断した場合に限ります
                        </Td>
                      </tr>
                    </tbody>
                  </table>
                  <AddText>
                    ※備考
                    <p>上記の各料金については、消費税は含まれていません。</p>
                    <p>
                      上記料金は旅行を中止される場合でも払戻いたしません。取扱・変更手続料金は当該手配を取消される場合でも払戻いたしません。
                    </p>
                    <p>
                      上記料金には電話料、通信費、送料等実費は含まれません。通信実費を別途申し受ける場合があります。
                    </p>
                    <p>航空会社・ホテル等旅行サービス提供機関等に対して支払う取消料は別途申し受けます。</p>
                    <p>「費用」とは、運賃･宿泊料その他の名目で、運送・宿泊機関等に対して支払う費用をいいます。</p>
                    <p>
                      「1手配」とは、依頼の最小単位（片道交通機関、1宿泊施設の予約等）とします。手配日・利用日・利用期間・利用区間・提供機関等が異なる場合はそれぞれ「1手配」と数えます。
                    </p>
                    <p>変更・取消手続料金は、手配着手後の変更・取消より申し受けます。</p>
                    <p>変更・取消・払戻は場合によりお引受できないことがあります。</p>
                    <br />
                    <p>本規約は、日本標準時間2017年9月27日より有効とします。</p>
                    <p>制定：2017年9月27日</p>
                    <p>改定：2019年10月15日</p>
                    <p>改定：2022年1月15日</p>
                    <p>改定：2022年3月1日</p>
                    <p>改定：2022年11月25日</p>
                    <p>改定：2026年2月13日</p>
                  </AddText>
                </InfoContent>
              </Body>
              <Footer signedIn={!!user} />
            </div>
          </div>
        </Wrap>
      );
    } catch (e) {
      reportError(e);
      return null;
    }
  }
}

export const Wrap = styled.div`
  &__small {
    font-size: 10px;
    margin-bottom: 5px;
    margin-left: calc(150px + 10px);
  }

  .key-value-table__label {
    width: 150px;
  }
`;

export const Body = styled(ContentBody)`
  max-width: 1150px;
  padding: 20px;
  background: none;
`;

export const InfoContent = styled.div`
  flex-grow: 9999;
  border: 10px solid #eee;
  padding: 10px;
  position: relative;
  background: white;
`;

export const Title = styled.h1`
  font-size: 20px;
  border-bottom: 1px solid ${props => props.theme.grayBorderColor};
  padding-bottom: 10px;
`;

export const Small = styled.div`
  font-size: 11px;
  margin-top: 10px;
`;

export const SubTitle = styled.h2`
  margin-top: 20px;
`;

const Column = css`
  border: solid 1px #eee;
  padding: 2px 4px;
  font-size: 12px;
  line-height: 20px;
`;

const Th = styled.th`
  ${Column}
  background-color: #f7f7f7;
  text-align: center;
`;

const Td = styled.td`
  ${Column}

  &:last-child {
    min-width: 100px;
  }
`;

export const AddText = styled.div`
  font-size: 12px;
  color: ${props => props.theme.grayTextColor};
`;

export default Charges;
